import { useLocation } from 'react-router-dom';
import { clientInputRoutes } from './route-declarations/client-input-routes';
import { homeViewRoutes } from './route-declarations/home-view-routes';

/**
 * Home view is only shown for
 * - logged in users
 * - who are either on the '/' route or
 * - or some other route specified in homeViewPaths (see below)
 */

export function useShouldShowHomeViewFrame(loggedInHomeViewEnabled: boolean) {
  const location = useLocation();
  if (!loggedInHomeViewEnabled) return false;

  const currentPath = location.pathname.split('/')[1];
  const isOnLander = currentPath.length === 0;
  const isOnHomeViewPath = homeViewPaths.some(
    homeViewPath => currentPath.slice(0, homeViewPath.length) === homeViewPath.split('/')[0],
  );

  return isOnLander || isOnHomeViewPath;
}

/**
 * In addition to homeViewPaths, home view frame is shown also for clientInputRoutes. They are declared separately because they can also be
 * shown without the home view frame for non-logged-in users who have a secret link.
 */
const homeViewPaths = [...homeViewRoutes.map(r => r.path), ...clientInputRoutes.map(r => r.path)];
